"use client";

import React from "react";
import { ArrowRight, Utensils, Music } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CulturalCulinaryExperience() {
  const headerReveal = useRevealOnScroll({
    threshold: 0.1
  });
  const section1Reveal = useRevealOnScroll({
    threshold: 0.2
  });
  const section2Reveal = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="222911" id="servizi-di-bordo-gold" className="bg-background text-foreground py-20 px-4 md:px-8 lg:px-16 overflow-hidden">
      <div className="max-w-7xl mx-auto space-y-20">
        {}
        <div ref={headerReveal.ref} className={`text-center max-w-3xl mx-auto space-y-4 transition-all duration-1000 ${headerReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-5xl font-bold font-default tracking-tight text-foreground">
            Servizi di Bordo Gold
          </h2>
          <p className="text-muted-foreground text-lg font-default">
            L'eccellenza della nautica di lusso a Ibiza: un'esperienza sartoriale 
            progettata per superare ogni aspettativa di comfort e prestigio.
          </p>
        </div>

        {}
        <div ref={section1Reveal.ref} className={`grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center transition-all duration-1000 delay-200 ${section1Reveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <div className="relative h-[400px] lg:h-[500px] rounded-md overflow-hidden shadow-lg border border-border">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/yacht_private_chef_service.png" alt="Chef Privato a bordo di uno yacht di lusso" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 hover:scale-105" />
            <div className="absolute inset-0 bg-gradient-to-t from-background/40 to-transparent pointer-events-none" />
          </div>

          <Card className="border-none bg-transparent h-full flex flex-col justify-center p-2 lg:p-6">
            <CardHeader>
              <div className="w-12 h-12 rounded-md bg-secondary/10 flex items-center justify-center mb-4 text-secondary">
                <Utensils className="w-6 h-6" />
              </div>
              <CardTitle className="text-2xl md:text-3xl font-default text-foreground">
                Chef Privato & Fine Dining
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-6">
              <CardDescription className="text-base md:text-lg text-muted-foreground font-default leading-relaxed">
                Deliziate il vostro palato con creazioni gourmet preparate sul momento 
                da chef stellati. Dalla selezione delle materie prime locali ai 
                pairing con i migliori champagne, ogni pasto è un evento esclusivo 
                che celebra i sapori del Mediterraneo in totale privacy.
              </CardDescription>
              <Button variant="outline" className="group border-primary text-primary hover:bg-primary hover:text-primary-foreground rounded-md">
                Scopri i menu Elite
                <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" />
              </Button>
            </CardContent>
          </Card>
        </div>

        {}
        <div ref={section2Reveal.ref} className={`grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center transition-all duration-1000 delay-300 ${section2Reveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <Card className="border-none bg-transparent h-full flex flex-col justify-center p-2 lg:p-6 order-2 lg:order-1">
            <CardHeader>
              <div className="w-12 h-12 rounded-md bg-secondary/10 flex items-center justify-center mb-4 text-secondary">
                <Music className="w-6 h-6" />
              </div>
              <CardTitle className="text-2xl md:text-3xl font-default text-foreground">
                Equipaggio Professionale
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-6">
              <CardDescription className="text-base md:text-lg text-muted-foreground font-default leading-relaxed">
                Un team dedicato di professionisti altamente qualificati è al vostro 
                servizio per garantire una navigazione impeccabile. Dalla gestione 
                tecnica alla cura di ogni dettaglio dell'ospitalità, il nostro 
                equipaggio incarna la discrezione e l'eccellenza del servizio NAVIS.
              </CardDescription>
              <Button variant="outline" className="group border-primary text-primary hover:bg-primary hover:text-primary-foreground rounded-md">
                I nostri standard di servizio
                <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" />
              </Button>
            </CardContent>
          </Card>

          <div className="relative h-[400px] lg:h-[500px] rounded-md overflow-hidden shadow-lg border border-border order-1 lg:order-2">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/yacht_professional_crew.png" alt="Equipaggio professionale NAVIS" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 hover:scale-105" />
            <div className="absolute inset-0 bg-gradient-to-t from-background/40 to-transparent pointer-events-none" />
          </div>
        </div>
      </div>
    </section>;
}